/**
 * Confirmación de "Cerrar sesión" (006 · T049; contracts/staff-ui.md §5, research R-15).
 *
 * Explica la consecuencia real antes de confirmar: para volver a usar Fermin en este teléfono hará
 * falta una nueva vinculación **aprobada por el administrador**. "Cerrar sesión" es destructivo;
 * "Cancelar" (terciario) cierra la hoja sin hacer nada. Mientras se cierra la sesión, la hoja no se
 * puede descartar.
 */
import { Button } from '../../components/ui/button';
import { Sheet } from '../../components/ui/sheet';
import { t } from '../../i18n';

export interface LogoutSheetProps {
  open: boolean;
  pending: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export function LogoutSheet({ open, pending, onConfirm, onCancel }: LogoutSheetProps) {
  return (
    <Sheet
      open={open}
      onClose={onCancel}
      dismissible={!pending}
      title={t('profile.logout.title')}
      description={t('profile.logout.description')}
      className="pb-fm-4"
      footer={
        <div data-testid="logout-sheet" className="flex flex-col gap-fm-3">
          <Button
            data-testid="logout-confirm"
            variant="destructive"
            onClick={onConfirm}
            loading={pending}
            loadingText={t('profile.logout.processing')}
          >
            {t('profile.logout.confirm')}
          </Button>
          <Button variant="ghost" onClick={onCancel} disabled={pending}>
            {t('profile.logout.cancel')}
          </Button>
        </div>
      }
    />
  );
}
